export default "__VITE_ASSET__91367074__"